/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Controls what a question does with the canonical shared value when it is edited on a
 * particular form version. Sharing itself is automatic (any question reused by
 * QuestionCode across versions of the same form template resolves to one shared value);
 * this only decides write-through vs. freeze.
 */
export enum CarryForwardMode {
    OVERWRITE_ORIGINAL = 'OverwriteOriginal',
    SAVE_SEPARATE = 'SaveSeparate',
    DO_NOT_CARRY_FORWARD = 'DoNotCarryForward',
}
